/** Passport photo: 35 × 45 mm at 300 DPI. Keep in sync with server/utils/profilePhoto.js. */
export var PASSPORT_PHOTO = { aspect: 35 / 45, width: 413, height: 531 };

/**
 * Crops the react-easy-crop pixel area into a passport-size rectangle.
 * Returns a JPEG data URL suitable for the existing Cloudinary upload flow.
 */
export function getCroppedImg(imageSrc, pixelCrop) {
  var width = PASSPORT_PHOTO.width;
  var height = PASSPORT_PHOTO.height;

  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.addEventListener("load", function () {
      try {
        var canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        if (!ctx) {
          reject(new Error("Canvas not supported"));
          return;
        }

        // JPEG has no transparency; areas zoomed out past the image stay white.
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, width, height);
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          width,
          height
        );

        resolve(canvas.toDataURL("image/jpeg", 0.92));
      } catch (err) {
        reject(err);
      }
    });
    image.addEventListener("error", function () {
      reject(new Error("Failed to load image"));
    });
    image.crossOrigin = "anonymous";
    image.src = imageSrc;
  });
}
